import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface PaymentTermsStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    terms?: TypographyProps;
}

export const PaymentTermsStyles: PaymentTermsStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h2",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
};

const styles = PaymentTermsStyles;

const PaymentTerms: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.terms) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="paymentTerms">
                {translate("Payment Terms")}
            </Typography>
            <Typography {...styles.terms} aria-labelledby="paymentTerms">
                {order.terms}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: PaymentTerms,
    definition: {
        allowedContexts: ["WorkOrderDetailsPage", "OrderDetailsPage"] as any,
        group: "Order Details",
    },
};

export default widgetModule;
